export const EMBED_AGENT_LOADER_JS_FILENAME = 'agent.js';

export const EMBED_AGENT_WIDGET_JS_FILENAME = 'agent-widget.js';

// The entry and globals stylesheets are content-hashed into `assets/`, so the CDN serves them with
// the hashed-asset cache policy instead of the fixed-name `no-store` one. As fixed names they were
// re-downloaded on every init(), and on a slow network that outlasted the pre-render CSS wait, so
// the widget painted unstyled. The runtime build (`vite-config/agent/runtime.ts`) swaps this
// placeholder for each file's real hash, both in the emitted file name and in the runtime JS.
// Hex hashes never contain `x`, so a placeholder that survives a build is unambiguous.
export const EMBED_AGENT_WIDGET_CSS_HASH_PLACEHOLDER = 'xxxxxxxx';

// Plain literals, not templates over the placeholder: the build matches these whole strings in the
// emitted JS, and a template is emitted split around its interpolation.
export const EMBED_AGENT_WIDGET_GLOBALS_CSS_FILENAME = 'assets/agent-widget.globals-xxxxxxxx.css';

export const EMBED_AGENT_WIDGET_CSS_FILENAME = 'assets/agent-widget-xxxxxxxx.css';
